<template>
  <div class="header">
    <div class="left">
      <div class="logo"></div>
      <div class="name">从前有条街</div>
    </div>
    <div class="right">
      <div class="btn reserve-btn" @click="reserve" v-if="stage == 0 && !isReserved"></div>
      <div class="btn download-btn" @click="mobileDownload" v-if="stage == 1"></div>
      <div class="nav-btn" :class="{ active: showNav == true }" @click="clickNavBtn">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
    <div class="nav" :class="{ active: showNav }">
      <div
        v-for="(item, key) in titleList"
        :key="key"
        class="nav__item"
        @click="jumpTo(item)"
      >
        <span class="text">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { isIOS, isWechat } from '@/utils/common.js'

import { mapMutations } from 'vuex'

export default {
  name: 'MobileHeader',
  computed: {
    stage() {
      return this.$store.getters.stage
    },
  },
  data() {
    return {
      showNav: false,
      titleList: [
        {
          name: '官网首页',
          height: 0,
        },
        {
          name: '有街头条',
          height: 161.066667,
        },
        {
          name: '预约奖励',
          height: 370.4,
        },
        {
          name: '邀请好友',
          height: 541.6,
        },
        {
          name: '名士风采',
          height: 698.533333,
        },
        {
          name: '游戏特色',
          height: 894.666666,
        },
        {
          name: '有街社区',
          height: 1061.466666,
        },
      ],
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage
    },
    isReserved() {
      return this.$store.getters.isReserved
    },
    isLogin() {
      return Object.keys(this.user).length > 0
    },
    isInvited() {
      return this.$route.query.inviteCode
    },
    downloadUrl() {
      return this.$store.getters.downloadUrl
    },
  },
  watch: {
    stage: function (val) {
      // 根据当前官网阶段设置标题
      if (val == 1) this.titleList[2].name = '下载有礼'
    },
  },
  created() {
    this.$nextTick(() => {
      const scrollHeight = this.$route.params.height
      if (scrollHeight) this.scrollTo(scrollHeight)
    })
  },
  methods: {
    ...mapMutations(['setTipsDialog', 'setLoginDialog', 'setWechatTipsVisible']),
    reserve() {
      if (this.$route.name != 'MobileHome') {
        this.$router.push({ name: 'MobileHome', params: { showReserve: true } })
      } else {
        this.$emit('reserve')
      }
    },
    mobileDownload() {
      if (isWechat()) {
        this.setWechatTipsVisible({ visible: true })
        return
      }

      // 根据移动端操作系统下载对应游戏包
      if (isIOS()) {
        this.download('ios')
      } else {
        this.download('android')
      }
    },
    download(os) {
      switch (os) {
        case 'ios':
          if (this.isInvited && !this.isLogin) {
            this.setLoginDialog({ visible: true })
            break
          }
          window.location.href = 'https://apps.apple.com/cn/app/%E4%BB%8E%E5%89%8D%E6%9C%89%E6%9D%A1%E8%A1%97/id6471931091'
          break;
        case 'android':
          if (this.isInvited && !this.isLogin) {
            this.setLoginDialog({ visible: true })
            break
          }

          if (!this.downloadUrl) {
            this.setTipsDialog({ visible: true, tips: '安卓下载地址获取失败，请刷新页面后重试' })
            break
          }
          window.open(this.downloadUrl)
          break;
      }
    },
    clickNavBtn() {
      this.showNav = !this.showNav
    },
    jumpTo(item) {
      let vw = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      let px = vw * 0.01
      const scrollHeight = item.height * px

      const routeName = this.$route.name
      if (routeName != 'MobileHome') {
        this.$router.push({ name: 'MobileHome', params: { height: scrollHeight } })
        return false
      }

      this.scrollTo(scrollHeight)

      this.showNav = false
    },
    scrollTo(height) {
      document.documentElement.scrollTo({
        top: height,
        behavior: 'smooth',
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4vw;
  width: 100%;
  height: 13.333333vw;
  background: url('~@/assets/img/mobile/header_bg.jpg') no-repeat;
  background-size: 100% 100%;

  .left {
    display: flex;
    align-items: center;
  }

  .logo {
    width: 10.933333vw;
    height: 10.933333vw;
    background: url('~@/assets/img/mobile/app.png') no-repeat;
    background-size: 100%;
  }

  .name {
    margin-left: 2.266666vw;
    font-size: 4.266666vw;
    color: #fff;
  }

  .right {
    display: flex;
    align-items: center;
  }

  .btn {
    width: 25.6vw;
    height: 8.533333vw;
    background: url('~@/assets/img/mobile/header_btn.png') no-repeat;
    background-size: 25.6vw;

    &.reserve-btn {
      background-position: 0 0;
    }
    &.download-btn {
      background-position: 0 -8.533333vw;
    }
  }

  .nav-btn {
    position: relative;
    margin-left: 5.333333vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 5.866667vw;
    height: 4.933333vw;

    .line {
      position: absolute;
      width: 5.866667vw;
      height: .4vw;
      background: #388176;
      border-radius: .2vw;
      transition: all .3s;
    }

    .line:nth-of-type(1) {
      top: 0;
    }
    .line:nth-of-type(2) {
      top: 2.266666vw;
    }
    .line:nth-of-type(3) {
      top: 4.533333vw;
    }

    &.active {

      .line:nth-of-type(1) {
        transform: rotate(45deg);
        top: 2.2vw;
      }
      .line:nth-of-type(2) {
        opacity: 0;
      }
      .line:nth-of-type(3) {
        transform: rotate(-45deg);
        top: 2.2vw;
      }
    }
  }

  .nav {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 0;
    overflow: hidden;
    background: rgba(0, 0, 0, .9);
    transition: all .3s;

    &.active {
      height: calc(100vh - 13.333333vw);
    }

    &__item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 6vw 0;
      width: 100%;
      font-size: 4vw;
      color: #beecde;
      border-bottom: .133333vw solid #203836;
    }
  }
}
</style>